import http from "./http_common";

class ConsentServices {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");
  }

  consentpost(data) {
    return http.post(`PatientConsentDetails/save`, data);
  }

  consentPostFromInviteLink(data) {
    return http.post(`PatientConsentDetails/save-from-invite-link`, data);
  }

  getconsentFilter(payload) {
    var queryString = this.queryString(payload);
    return http.get(`PatientConsentDetails/list/filter?${queryString}`);
  }

  getconsentFilterForLink(payload) {
    var queryString = this.queryString(payload);
    return http.get(`PatientConsentDetails/list/consentDetails?${queryString}`);
  }

  GetAppointmentId(id) {
    return http.get(`invitationDetails/list/filter?appointmentId=${id}`);
  }
  consentPostFromInviteLinkForMobile(data) {
    return http.post(`/PatientConsentDetails/saveconsent`, data);
  }

  ShareMedicalrecordsFromLinkForMobile(data) {
    return http.post(`/patientHistoryAccess/savehistoryaccess`, data);
  }
}

export default new ConsentServices();
